












import { Vue, Component, Prop } from 'vue-property-decorator';
import {namespace} from "vuex-class";

import {errorHandler} from '@/services/services';
import OpenHub from '@/views/components/openHub/OpenHub.vue';
import {IActiveShipment} from "@/models/StoreModels";
import {OPEN_HUB_MODES} from "@/constants/openHub";
import ShowOneHub from "@/views/components/Home/dropup/ShowOneHub.vue";
import DropupLayout from "@/views/Dropups/DropupLayout.vue";
import {IDropupParams} from "@/models/BasicModels";
import {selectHubDropupParams} from "@/constants/dropUpParams";

const activeShipmentsModule = namespace('activeShipments');


@Component({
  name: 'OpenHubSharedLogic',
  components: {
    OpenHub,
    ShowOneHub,
    DropupLayout,
  },
})
export default class OpenHubSharedLogic extends Vue {
  @Prop({default:  -1})
  private hubId!: number|string;

  private dropupValues: IDropupParams = selectHubDropupParams;

  private showOneHub(hubId: number|string) {
    this.$uiBus.emit("dropup:open"); // to open with the route
  }
}
